export const recipts = [{ name: 'Vegan matcha shake',
prev: 'bananen_shake.jpg',
time: '10 min.',
ingredients:
 [ '½ liter of almond milk',
   '1 ripe banana',
   '2 dates',
   '1 teaspoon chia seeds',
   '1.5 teaspoons matcha powder',
   ', ½ teaspoon lemon juice' ],
preparation:
 [ 'Peel the banana and mix together with the almond milk, the dates, the chia seeds and the matcha powder in a tall container or puree.',
   'Pour shake into a glass. Stir the lemon juice into the shake and serve.' ],
portions: 1,
tags: [ 'Wachmacher', 'Snacks', 'Drink', 'Vegan' ] },
{ name: 'Tomato soup vegan',
prev: 'vegan_tomaten_suppe.jpg',
time: '30 min.',
ingredients:
 [ '½ onion',
   '1 clove of garlic',
   '1 chili pepper',
   '2 oranges (unsprayed)',
   '2 tbsp olive oil',
   '2 teaspoons tomato paste',
   '1 kl. Tin peeled tomatoes (150 g)',
   '200 ml of salted water',
   ', Salt, pepper, herbs' ],
preparation:
 [ 'Peel onion and garlic, finely chop. Wash the chili pepper, cut into fine rings. Peel oranges and squeeze around 120 ml of juice. Put the peel aside half an orange.',
   'Heat olive oil in a pan. Put the onion cubes, garlic and chili in the pan, sauté briefly. Then add the tomato paste and fry briefly. Add orange juice and the half orange peel to the pan. Let it cook for a short time.',
   'Drain the canned tomatoes and add to the pan with salted water. Bring to a boil and cook over medium heat for 15-20 minutes.',
   'Take Organgenschale from the soup. Puree the soup. Season with salt, pepper and herbs.' ],
portions: 2,
tags: [ 'Der Klassiker', 'Lunch', 'Vegan' ] },
{ name: 'Spicy coconut-lentil soup',
prev: 'scharfe_kokos_linsensuppe_vegan.jpg',
time: '25 min.',
ingredients:
 [ '1 piece ginger (hazelnut size)',
   '1 onion',
   ', 300 ml of coconut milk',
   '150 ml of water',
   '100 g red lentils',
   '2 tbsp olive oil',
   '1 can of tomato pieces (200 g)',
   ', ½ lemon',
   ', Salt, pepper, chilli powder' ],
preparation:
 [ 'Peel the onion and ginger, cut into fine pieces. Bring water to a boil in a kettle.',
   'Heat olive oil in a high pan. Add ginger, onion and lentils, sauté briefly.',
   'Coconut milk, the boiled water and tomato pieces in the pan. Season with chili powder. Bring to a boil and simmer for about 10 minutes.',
   'Season with salt, pepper and lemon juice.' ],
portions: 2,
tags: [ 'Exotisch', 'Lunch', 'Vegan' ] },
{ name: 'Vegan ginger carrot soup',
prev: 'vegane_ingwer_karotten_suppe.jpg',
time: '30 min.',
ingredients:
 [ '1 onion',
   ', 300 g of carrots',
   '100 ml of salted water',
   '1 piece ginger (hazelnut size)',
   ', ¼ bunch of parsley',
   '2 tbsp olive oil',
   ',Salt pepper' ],
preparation:
 [ 'Peel the onion and ginger, finely dice. Wash carrots, peel and cut into small pieces.',
   'Heat olive oil in a pot. Sauté onion pieces until they are glassy. Then add the carrot and ginger pieces and sauté briefly. Sauté the vegetables with salted water and simmer for about 15 - 20 minutes over medium heat.',
   'Puree the soup and season with salt and pepper. Wash the parsley, chop and sprinkle over the soup.' ],
portions: 2,
tags: [ 'Vitaminbombe', 'Lunch', 'Vegan' ] },
{ name: 'Vegan spinach coconut soup',
prev: 'vegane_kokos_spinat_suppe.jpg',
time: '25 min.',
ingredients:
 [ '200 ml of coconut milk',
   '100 g of celery',
   '250 ml of water',
   '100 g of fennel',
   '200 g leaf spinach',
   ', ½ chili pepper',
   '1 carrot',
   '1 piece ginger (hazelnut size)',
   ',Salt pepper' ],
preparation:
 [ 'Put water and coconut milk in a saucepan and bring to a boil.',
   'Wash the fennel and celery, peel and cut into fine pieces. Add the vegetables to the saucepan and cook over medium heat for about 10 minutes.',
   'Wash spinach, finely chop. Wash carrot, peel and cut into thin strips. Peel ginger, finely chop. Wash chili, cut into fine rings.',
   'Add all ingredients to the soup and simmer over low heat for 4 minutes. Season with salt and pepper.' ],
portions: 2,
tags: [ 'Exotisch', 'Lunch', 'Vegan' ] },
{ name: 'Chickpea cauliflower salad',
prev: 'kichererbsen_blumenkohlsalat_vegan.jpg',
time: '20 min.',
ingredients:
 [ '1/2 cauliflower',
   '1 can of chickpeas (240 g drained weight)',
   '2 bars of spring onions',
   ', ¼ bunch of parsley',
   ', 3 tablespoons olive oil',
   ', ½ lemon',
   '1 tsp curry',
   ',Salt pepper' ],
preparation:
 [ 'Wash the cauliflower, divide into fine florets and cut into small pieces. Heat olive oil in a pan. Brown cauliflower for about 10 minutes over medium heat.',
   'Drain chickpeas, rinse with water. Then place in a bowl and add 1 tablespoon of olive oil. Wash spring onions, cut into fine rings. Wash parsley, finely chop. Mix the onion and parsley with the chickpeas.',
   'Squeeze out the lemon and put the lemon juice in the bowl as well. Add cauliflower. Season with curry, salt and pepper. Allow to cool before serving.' ],
portions: 2,
tags: [ 'Gut vorzubereiten', 'Snacks', 'Vegan' ] },
{ name: 'Vegan Thai curry with sweet potatoes',
prev: 'veganes_thai_curry_suesskartoffeln.png',
time: '30 min.',
ingredients:
 [ '2 big sweet potatoes',
   '1 broccoli',
   ', ½ bunch of spring onions',
   '1 red pepper',
   '2 carrots',
   '1 kl. Can of coconut milk',
   '1 lime',
   '1 tablespoon soy sauce',
   '1 tbsp olive oil',
   ', Salt, pepper, curry powder' ],
preparation:
 [ 'Wash potatoes, peel and cut into small pieces.',
   'Wash remaining vegetables and cut into small pieces. Squeeze out lime.',
   'Heat olive oil in a pan. Add the carrot pieces, sauté briefly. Then gradually add broccoli, paprika and spring onion. Sauté briefly. Season with salt, pepper and curry powder.',
   'Add lime juice, soy sauce and the coconut milk. Add potato pieces to it. Simmer over low heat until the sweet potatoes are ready. Serve and serve.' ],
portions: 2,
tags: [ 'Sättigend', 'Lunch', 'Vegan' ] },
{ name: 'Vegan vegetable pan with sweet potatoes',
prev: 'vegane_gemuesepfannesuesskartoffeln.jpg',
time: '30 min.',
ingredients:
 [ '1 big sweet potato',
   '1 onion',
   ', 3 carrots',
   '1 tbsp olive oil',
   '1 broccoli',
   ', 300 ml of salted water',
   ',Salt pepper' ],
preparation:
 [ 'Wash onions and carrots, peel and cut into thin cubes. Wash broccoli, cut stalk, peel, cut into small cubes. Cut off broccoli florets. Wash sweet potatoes, peel and dice.',
   'Heat olive oil in a pan. Add the onion and carrot cubes to the pan and sauté.',
   'Add the potato cubes, fry briefly. Then add the salted water. Add broccoli pieces.',
   'Close pan with lid and simmer for about 15 minutes over medium heat.' ],
portions: 2,
tags: [ 'Ballaststoffreich', 'Lunch', 'Vegan' ] },
{ name: 'Vegan tofu curry',
prev: 'veganes_tofu_curry.jpg',
time: '25 min.',
ingredients:
 [ '300 g of tofu',
   '1 small piece of ginger (1 cm)',
   '1 bunch of spring onions',
   '2 carrots',
   '1 yellow pepper',
   ', 30 g of cashew nuts',
   '100 ml of salted water',
   '1 tbsp olive oil',
   ', Salt, pepper, curry powder' ],
preparation:
 [ 'Peel ginger and mince it. Wash carrots, peppers and spring onions, cut into small pieces. Roughly chop the cashews. Dice tofu.',
   'Heat olive oil in a pan. Add the ginger, carrot and pepper pieces to the pan and sauté briefly.',
   'Add the tofu cubes. Season all ingredients with salt, pepper and curry powder. Continue roasting for 2 minutes.',
   'Add 100 ml of salted water to the pan. Let it boil down. Season with salt, pepper and curry.' ],
portions: 2,
tags: [ 'Exotisch', 'Lunch', 'Vegan' ] },
{ name: 'Chili sin carne',
prev: 'chili_sin_carne.jpg',
time: '30 min.',
ingredients:
 [ '300 g of tofu',
   '1 onion',
   '1 clove of garlic',
   '1 red pepper',
   '1 red hot pepper',
   '250 ml of passed tomatoes',
   '1 small tin of corn kernels',
   '1 small tin of kidney beans',
   '1 tbsp olive oil',
   ', Salt, pepper, chilli powder' ],
preparation:
 [ 'Dice tofu. Mix 1 tablespoon of olive oil with some chilli powder and turn the tofu cubes into it.',
   'Peel onion and garlic cubes and finely chop. Wash the peppers and chili peppers, core them, cut into fine pieces.',
   'Heat olive oil in a pan. Sauté the tofu cubes, season with salt and pepper, then remove again and keep warm. Add the onion, garlic and pepper to the pan, sauté briefly. Add the tomatoes, season with salt and pepper. Simmer over medium heat for 5 minutes.',
   'Rinse corn and kidney beans and add. Cook over medium heat. Fold in tofu cubes. Season with salt, pepper and chili powder.' ],
portions: 2,
tags: [ 'Fleischlose Alternative', 'Lunch', 'Vegan' ] },
{ name: 'Vegan chanterelle pan',
prev: 'vegane_pfifferlingspfanne.jpg',
time: '30 min.',
ingredients:
 [ '300 g fresh chanterelles',
   '1 onion',
   '1 bunch of chives',
   '2 tbsp olive oil',
   '150 ml soy cream',
   '1 tbsp mustard',
   ',Salt pepper' ],
preparation:
 [ 'Washing chanterelles. Peel the onion and cut into fine cubes. Wash the chives and cut into fine rings.',
   'Heat olive oil in a pan. Add chanterelles and sauté briefly. Add the onion pieces and fry briefly. Season with salt and pepper.',
   'Add soy cream and simmer briefly.',
   'Stir mustard into the sauce, season with salt and pepper. Add the chives and stir.' ],
portions: 2,
tags: [ 'Ballaststoffreich', 'Lunch', 'Vegan' ] },
{ name: 'Vegan quinoa-vegetable pan',
prev: 'vegane_quinoa_gemuese_pfanne.jpg',
time: '30 min.',
ingredients:
 [ '250 g of broccoli',
   '1 red pepper',
   '1 clove of garlic',
   '1 carrot',
   '2 tbsp olive oil',
   ', 75 g peas (from the freezer)',
   '200 ml of salted water',
   '100 g quinoa',
   ', Salt, pepper, curry powder' ],
preparation:
 [ 'Wash broccoli, cut stalk, peel and cut into florets. Then also cut the roses.',
   'Wash the peppers, core them and cut into fine cubes. Wash the carrot, peel it into thin slices. Peel garlic, finely chop.',
   'Rinse quinoa in a sieve with water. Bring about 400 ml of water to a boil. Add quinoa. Simmer for 12 minutes. Remove from heat, salt and leave to soak for another 10 minutes.',
   'Heat olive oil in a pan. Add the pepper, broccoli, carrot and garlic to the pan and fry for 5 minutes over medium heat. Add peas. Season with curry, salt and pepper.',
   'Add salted water. Boil. Add quinoa and cook for 5 minutes.' ],
portions: 2,
tags: [ 'Nährstoffreich', 'Lunch', 'Vegan' ] },
{ name: 'Beans with soy cream',
prev: 'bohnen_soja.jpg',
time: '30 min.',
ingredients:
 [ '200 g of green, thick beans',
   '1 onion',
   '1 tbsp olive oil',
   '150 g peas (tin)',
   '2 bars of celery',
   '1 tbsp lemon juice',
   '100 ml of soy cream',
   ', Salt, pepper, herbs' ],
preparation:
 [ 'Wash beans. (Depending on the taste, the peel can be removed by briefly placing the beans in boiling water and removing the peel). Drain the peas.',
   'Wash the celery, peel and cut into small cubes. Peel onion, finely chop.',
   'Heat olive oil in a pan. Add the celery and onion, sauté briefly. Add beans and peas, continue to simmer for about 1 minute.',
   'Add lemon juice and let it boil down. Add soy cream. Bring to a boil. Simmer over medium heat for 5 minutes.',
   'Arrange with herbs and serve as desired.' ],
portions: 2,
tags: [ 'Leicht', 'Lunch', 'Vegan' ] },
{ name: 'Vegan tofu vegetable pan',
prev: 'vegane_tofu_gemuese_pfanne.jpg',
time: '35 min.',
ingredients:
 [ '1 stick of leek',
   ', 80 g amaranth',
   '200 g of tofu',
   '1 pepper',
   ', 350 g of carrots',
   '1 tbsp olive oil',
   '150 ml of water',
   ', ½ bunch of parsley',
   ', ½ lemon',
   ',Salt pepper' ],
preparation:
 [ 'Salt the water in a saucepan. Add amaranth and bring to a boil. Let the amaranth swell for about 20 minutes on low heat.',
   'Peel carrots, cut into slices. Wash the leek and cut into rings. Wash the lemon and rub the skin. Cut tofu into strips. Wash parsley, mince. Wash the peppers, remove seeds, cut into small pieces.',
   'Heat olive oil in a pan. Sauté the tofu for a short time. Add the leek, sauté briefly. Then add carrots, also steam briefly. Add amaranth with a little water and cook for 5 minutes.',
   'Add parsley. Season with salt, pepper and lemon zest.' ],
portions: 2,
tags: [ 'Mit Amaranth', 'Lunch', 'Vegan' ] },
{ name: 'Vegan curry stew',
prev: 'veganer_curry_eintopf.jpg',
time: '35 min.',
ingredients:
 [ '½ leek',
   '1 big sweet potato',
   '2 tbsp olive oil',
   '100 g of lenses',
   '1TL tomato paste',
   '200 ml of water',
   ', Salt, pepper, curry powder' ],
preparation:
 [ 'Wash the leek, cut into rings. Wash sweet potatoes, peel, cut into cubes.',
   'Heat olive oil in a pan. Sauté the leek, sweet potato and lentils briefly. Add the tomato puree, season with curry and deglaze with water. Season with salt and pepper. Simmer with occasional stirring for about 15 minutes.',
   'Season with salt, pepper and curry again. Arrange with herbs and serve as desired.' ],
portions: 2,
tags: [ 'Sättigend', 'Lunch', 'Vegan' ] },
{ name: 'Carrots apricot curry',
prev: 'karotten_aprikosen_curry.jpg',
time: '30 min.',
ingredients:
 [ '200 g of tofu',
   '1 big onion',
   ', 300 g of carrots',
   '100 g apricots (tin)',
   '1 clove of garlic',
   '100 ml of coconut milk',
   ', 75 ml of water',
   '1 tbsp olive oil',
   '1 chili pepper',
   ', Salt, pepper, curry powder' ],
preparation:
 [ 'Cut tofu into strips. Cut the apricots into fine cubes and keep the juice out of the can. Peel onions, carrots and garlic, cut into thin cubes. Wash the chili pepper, cut into fine rings.',
   'Heat olive oil in a pan. Fry the tofu strips on all sides over medium heat. Season with salt and pepper, remove and warm.',
   'Put the garlic and onion into the pan and sauté briefly. Then add the carrot pieces, also sauté briefly. Season with curry and deglaze with water.',
   'Add apricot pieces and juice, chilli rings, coconut milk. Season with salt and pepper. Add the tofu and let it steep for 10 minutes.' ],
portions: 2,
tags: [ 'Exotisch', 'Lunch', 'Vegan' ] },
{ name: 'Chili con carne',
prev: 'chili_con_carne.jpg',
time: '25 min.',
ingredients:
 [ '300 g minced beef',
   '1 chili pepper',
   '1 onion',
   ', ½ clove of garlic',
   '1 big can of tomatoes',
   '1 teaspoon chilli powder',
   '1 tin of kidney beans (250g)',
   '2 tbsp olive oil',
   ',Salt pepper' ],
preparation:
 [ 'Peel garlic clove and onion, cut into small cubes. Heat olive oil in a pan. Sweat the onion and garlic for 5 minutes.',
   'Wash and chop the chili pepper. Add to the pan with the chili powder. Braise for about 2 minutes.',
   'Add the minced meat and sauté. Stir in tomatoes and kidney beans. Season with salt and pepper.',
   'Simmer for about 90 minutes over medium heat.' ],
portions: 2,
tags: [ 'Gut vorzubereiten', 'Lunch' ] },
{ name: 'Beef paprika pan',
prev: 'rindfleisch_paprika.png',
time: '20 min.',
ingredients:
 [ '2 pieces of steak meat',
   '1 onion',
   '1 pepper',
   '1 hot pepper',
   '2 tbsp olive oil',
   ', If desired: 1 tablespoon soy sauce',
   ',Salt and pepper' ],
preparation:
 [ 'Wash the peppers and hot peppers, remove seeds and cut into strips. Peel onion, cut into rings. Cut meat into strips.',
   'Heat olive oil in the pan. Fry the meat strips and season with salt and pepper. Add the peppers, onion and pepper and sauté briefly.',
   'Chill and serve with soy sauce as desired.' ],
portions: 2,
tags: [ 'Deftig', 'Lunch' ] },
{ name: 'Süßkartoffelspalten',
prev: 'suesskartoffelspalten.jpg',
time: '30 min.',
ingredients:
 [ '3-4 sweet potatoes',
   ', 3 garlic cloves',
   ', Salt, pepper, possibly paprika powder',
   ', 3 tablespoons olive oil',
   ', 3 tablespoons of lean herb quark' ],
preparation:
 [ 'Wash the potatoes and cut into equal sized slices. Distribute evenly on a baking sheet lined with baking paper.',
   'Preheat oven to 200 degrees. Peel the garlic cloves and chop them into fine pieces. Mix with olive oil and season with salt, pepper and paprika.',
   'Spread the garlic and spice mixture evenly on the potato wedges. Bake in the oven for 15-20 minutes.',
   'Arrange potato wedges with herb quark and serve.' ],
portions: 2,
tags: [ 'Gesunde Alternative', 'Lunch', 'Snacks' ] },
{ name: 'Redfish on chanterelles',
prev: 'rotbarsch_auf_pfifferlingen.jpg',
time: '30 min.',
ingredients:
 [ '2 redfish halves (300g)',
   ', ½ onion',
   '150 g chanterelles (fresh or frozen)',
   ', ½ bunch of spring onions',
   '200 g of small tomatoes',
   '2 tbsp olive oil',
   '1 tbsp lemon juice',
   ',Salt and pepper' ],
preparation:
 [ 'Wash fish and remove any bones.',
   'Drizzle fillets with lemon juice and season with salt.',
   'Peel the onion, chop it into fine pieces. Wash the spring onion, cut into fine rings. Washing chanterelles.',
   'Wash tomatoes. Put hot water from the kettle into a bowl. Cut a small slit into the tomatoes and add to the hot water. Remove after a few minutes and peel off the skin.',
   'Put olive oil in a pan and heat. Add pieces of onion and fry until glassy. Then add chanterelles and sauté for about 8 minutes.',
   'Add the spring onions and tomatoes to the chanterelles. Let it rest for about 3 minutes. Then season with salt and pepper.',
   'In a separate pan fry the fish fillets in & nbsp; olive oil from both sides for 3 minutes.' ],
portions: 2,
tags: [ 'Proteinreich', 'Lunch' ] },
{ name: 'Chili con carne omelette',
prev: 'chili_con_carne_omelette.jpg',
time: '30 min.',
ingredients:
 [ '4 eggs',
   '1 onion',
   '1 clove of garlic',
   '2 tbsp olive oil',
   '1 red pepper',
   '1 big can of tomatoes',
   '250 g ground beef',
   '1 chili pepper',
   '1 teaspoon chilli powder',
   '1 tin of kidney beans (250g)',
   ',Salt pepper' ],
preparation:
 [ 'Wash the peppers and dice them. Peel the onion and garlic clove and chop them into fine pieces. Wash chilli pepper and cut into fine rings.',
   'Heat the olive oil in the pan and fry the minced meat. Add the chili, onion, garlic and pepper pieces and fry for 2 minutes.',
   'Add tomatoes and kidney beans from the tin. Season with salt, pepper and chili powder. Stir and simmer for a few minutes.',
   'In the meantime, heat olive oil in a second pan. Add 2 whisked eggs to an omelette on low heat. Season the raw eggs with salt and pepper as desired. Turn the omelette gently and remove from the pan. Make the second omelette in the same way.',
   'Spread the finished chili on the omelets and fold.' ],
portions: 2,
tags: [ 'Low Carb', 'Breakfast', 'Lunch', 'Dinner', 'Snacks' ] },
{ name: 'Stuffed couscous peppers with feta',
prev: 'couscous_paprika_mit_feta.jpg',
time: '30 min.',
ingredients:
 [ '2 peppers',
   '100 g of raw couscous',
   '1 tbsp olive oil',
   '100 g feta cheese',
   ', 50 g of olives (pitted)',
   ', 3 cherry tomatoes',
   ', Salt, pepper, basil' ],
preparation:
 [ 'Cut the peppers in half, corer them and wash them.',
   'Bring salted water to a boil in a saucepan. Remove from the heat and add couscous with stirring. Cover with a lid and allow to swell on low heat for 5 minutes.',
   'Dice the feta cheese. Wash olives and cut into fine pieces. Wash the tomatoes, cut into fine pieces. Mix cheese, olives and tomatoes with couscous. Season with salt, pepper and basil.',
   'Preheat oven to 200 degrees Celsius. Fill the peppers with couscous-feta mixture. Put in the oven and bake for 20 minutes' ],
portions: 2,
tags: [ 'Gut vorzubereiten', 'Lunch' ] },
{ name: 'Kasseler in apple mustard sauce',
prev: 'kasseler_apfel.jpg',
time: '30 min.',
ingredients:
 [ '2 bacon cutlets without bone',
   '2 apples',
   '100 ml vegetable broth',
   '2 tablespoons of lemon juice',
   '2 tablespoons mustard',
   ',Salt pepper' ],
preparation:
 [ 'Wash apples, peel and cut into small cubes. Then sprinkle with lemon juice.',
   'Heat the pan with olive oil and roast for about 3 minutes from each side. Add the apple cube and fry for a further 7 minutes at low heat. Season with salt and pepper.',
   'Remove the Kasseler slices from the pan and keep warm. Douse the apple cubes with the vegetable stock. Stir in the mustard and, if necessary, season again with salt and pepper. Put Kasseler in the pan and let it rest for 10 minutes.',
   'Serve and enjoy!' ],
portions: 2,
tags: [ 'Deftig', 'Lunch' ] },
{ name: 'Salmon on savoy cabbage',
prev: 'lachs_bohnen.jpg',
time: '30 min.',
ingredients:
 [ '350 g savoy cabbage',
   ', 4 tablespoons low-fat cream',
   ', 300 g salmon fillet without skin',
   '2 teaspoons olive oil',
   '1 lemon sliced',
   ', 50 ml low-fat milk',
   '1 tsp dill',
   ', Curry powder, nutmeg, salt, pepper' ],
preparation:
 [ 'Wash the savoy cabbage and cut into strips. Bring salted water to a boil. Add the savoy cabbage and cook until the strips are soft.',
   'Put cream and milk in another pot and heat. Bring to a boil until half evaporates. Add the savoy cabbage and season with curry, nutmeg, salt and pepper.',
   'Heat olive oil in a pan. Roast the salmon fillets over medium heat for about 3 minutes. Season with salt and pepper.',
   'Serve everything on a plate and cover salmon with lemon slices, dill sprinkle.' ],
portions: 2,
tags: [ 'Nährstoffreich', 'Lunch' ] },
{ name: 'Colorful oven vegetables',
prev: 'buntes_ofengemuese.jpg',
time: '35 min.',
ingredients:
 [ '1 zucchini',
   '1 red pepper',
   '1 yellow pepper',
   ', 300 g of mushrooms',
   ', 4 tomatoes',
   '1 tbsp olive oil',
   ', Salt, pepper, herbs, e.g. herbs of Provence' ],
preparation:
 [ 'Preheat oven to 200 degrees Celsius.',
   'Wash vegetables and slice. Eat tomatoes.',
   'Lay the baking tray with baking paper and brush with oil. Place vegetables on the baking tray. Season with salt, pepper and herbs as desired.',
   'Bake for 20 minutes.' ],
portions: 2,
tags: [ 'Leicht', 'Lunch', 'Vegan' ] },
{ name: 'Curry bean stew',
prev: 'burry_bohnen_eintopf.jpg',
time: '35 min.',
ingredients:
 [ '1 zucchini',
   '1 onion',
   '1 pepper',
   ', 500 ml of water',
   '1 can of white beans',
   '1 bunch of soup vegetables: 2 carrots, ½ stick of leek, 1 piece of celery',
   ', As desired: 2 pieces of wiener sausage (low-fat turkey meat)',
   ', Salt, pepper, curry' ],
preparation:
 [ 'Wash vegetables, cut small. Heat olive oil in a pot. Add the vegetables and sauté briefly. Season with salt, pepper and curry. Add the water and simmer for about 20 minutes.',
   'Wash beans with water, then put in the pot. Simmer for about 10 minutes.',
   'Serve and serve. If you like, you can cut low-fat turkey sausage pieces.' ],
portions: 2,
tags: [ 'Deftig', 'Lunch' ] },
{ name: 'shrimp pan',
prev: 'garnelenpfanne.jpg',
time: '20 min.',
ingredients:
 [ '400 g shrimp (fresh or frozen)',
   '250 g cherry tomatoes',
   '250 g mushrooms',
   '1 lemon',
   '1 tsp mustard',
   ', 4 spring onions',
   '1 tbsp olive oil',
   ', Salt, pepper, parsley' ],
preparation:
 [ 'Thaw frozen prawns before preparation.',
   'Heat olive oil in a pan. Sauté shrimp briefly and deglaze with lemon juice.',
   'Wash mushrooms, tomatoes and spring onion. Halve mushrooms and tomatoes. Cut the spring onion into rings. Put the mushrooms in the pan and sauté briefly.',
   'Add cherry tomatoes and the spring onions to the pan. Braise briefly.',
   'Season with salt, pepper and mustard. Serve and sprinkle with parsley.' ],
portions: 2,
tags: [ 'Leicht', 'Lunch' ] },
{ name: 'Herb salmon with beans',
prev: 'krrauter_lachs_mit_bohnen.jpg',
time: '30 min.',
ingredients:
 [ '2 salmon steaks without skin',
   ', 40 g of olives',
   '200 g of green beans',
   '1 tbsp low-fat cream cheese',
   '2 teaspoon herb butter',
   ', 4 cherry tomatoes',
   ',Salt pepper' ],
preparation:
 [ 'Season salmon steaks with salt and pepper. Wash olives and cut into fine rings. Mix the olives with the herb butter and cream cheese. Season with salt and pepper.',
   'Wash beans and cook over medium heat in salted water.',
   'Wash tomatoes, cut in half. Place with the salmon steaks in a grill pan and sauté the fish for about 3 to 4 minutes from both sides.',
   'Serve salmon steaks on plates. Melt the herb butter cream cheese cream on the fish & nbsp; Add beans and serve.' ],
portions: 1,
tags: [ 'Proteinreich', 'Lunch' ] },
{ name: 'Falafelpizza',
prev: 'falafelpizza.jpg',
time: '30 min.',
ingredients:
 [ '1 egg',
   '1 onion',
   '1 pack of falafel mix',
   ', 3 tomatoes',
   '2 slices of ham',
   '1 pepper',
   '100 g mushrooms' ],
preparation:
 [ 'Peel the onion and chop it into fine pieces. Wash tomatoes and mushrooms, cut into small pieces. Wash the peppers, remove seeds and cut into thin strips. Slice the ham slices into small pieces.',
   'Preheat oven to 200 degrees Celsius.',
   'Prepare falafel mixture according to package instructions. Let it swell briefly.',
   'Mix the prepared falafel mixture with the onion cubes and the egg. Then spread on a baking sheet lined with baking paper and bake for about 5 minutes.',
   'Remove the falafel pizza base from the oven and garnish with ham and vegetables. Possibly. sprinkle with Parmesan. Put it back in the oven and bake for another 10 minutes.' ],
portions: 2,
tags: [ 'Gesunde Alternative', 'Lunch', 'Snacks' ] },
{ name: 'Putenwraps',
prev: 'putengeschnetzeltes_mit_tomaten.jpg',
time: '30 min.',
ingredients:
 [ '4 eggs',
   '2 tablespoons of ground almonds',
   '1 tbsp olive oil',
   '200 g turkey slices',
   ', 4 cherry tomatoes',
   '1 pepper',
   '2 tsp mustard',
   ',Salt pepper' ],
preparation:
 [ 'Preheat olive oil in a pan.',
   'Mix the eggs and the ground almonds well together. Season with salt and pepper as desired.',
   'Add half of the liquid to the pan. Distribute by panning in the pan. Increase over medium heat. Repeat the process for the second wrap bottom.',
   'Wash tomatoes and cut into small pieces. Wash the peppers, remove seeds and cut into small pieces.',
   'Heat olive oil in another pan. Put in the turkey and sauté briefly. Season with salt and pepper.',
   'Coat both wrap bottoms with mustard. Cover with turkey and vegetables. Curl up and enjoy.' ],
portions: 1,
tags: [ 'Proteinreich', 'Lunch', 'Snacks' ] },
{ name: 'Curry Coconut Lentil Pot',
prev: 'kokos_linsen.jpg',
time: '20 min.',
ingredients:
 [ '1 large doses of lentils',
   ', ½ bunch of spring onions',
   '2 tbsp curry powder',
   '1 tsp cayenne pepper',
   '1 teaspoon cumin',
   ', ½ can of coconut milk',
   '1 tbsp olive oil',
   ',Salt pepper' ],
preparation:
 [ 'Heat olive oil in a pan.',
   'Wash the spring onions and cut into rings. Add to the pan and sauté briefly. Add coconut milk and lentils. Season with spices to taste. Simmer for 15-20 minutes.' ],
portions: 1,
tags: [ 'Exotisch', 'Lunch', 'Vegan' ] },
{ name: 'Vegetable salmon pan',
prev: 'lachsfilet_auf_gemuese.jpg',
time: '30 min.',
ingredients:
 [ '1 zucchini',
   '150 g salmon (without skin)',
   '1 carrot',
   '1 broccoli',
   '1 onion',
   '1 tbsp olive oil',
   ',Salt pepper' ],
preparation:
 [ 'Wash vegetables and cut into small pieces. Peel carrot and onion, cut into fine pieces. Preheat olive oil in a pan.',
   'Add salmon to the pan and fry on both sides over medium heat. After 3 minutes, put the vegetables in the pan and sauté as well. Occasionally deglaze with water.',
   'Season with salt and pepper.' ],
portions: 2,
tags: [ 'Nährstoffreich', 'Lunch' ] },
{ name: 'Turkeys coconut pan',
prev: 'puten_kokos_pfanne.jpg',
time: '20 min.',
ingredients:
 [ '400 g turkey slices',
   '1 can of mushrooms',
   '1 spring onion',
   '1 small tin of green beans',
   '250 ml of passed tomatoes',
   '20 ml of coconut milk',
   '2 tablespoons tomato pesto',
   '1 tbsp olive oil',
   ',Salt pepper' ],
preparation:
 [ 'Wash the spring onion and cut into fine rings. Drain mushrooms and beans. Heat olive oil in a pan.',
   'Slice the turkey and fry the onion rings over medium heat. Passed tomatoes, coconut milk and pesto.',
   'Add mushrooms and beans. Season with salt and pepper. Simmer for about 10 minutes over medium heat.' ],
portions: 2,
tags: [ 'Superschnell', 'Lunch' ] },
{ name: 'Turkey sliced with peanut sauce',
prev: 'putengeschnetzeltes_mit_curry_kokosmilch.jpg',
time: '30 min.',
ingredients:
 [ '400 turkey slices',
   '200 ml of coconut milk',
   '250 ml vegetable broth',
   ', 4 tablespoons peanut butter (unsweetened)',
   '2 carrots',
   '1 clove of garlic',
   '1 chili pepper',
   '1 spring onion',
   '200 g of broccoli',
   ', ½ lemon',
   '2 tbsp olive oil',
   ',Salt pepper' ],
preparation:
 [ 'Wash broccoli and spring onion, cut into slices. Wash carrot, peel and slice. Squeeze out lemon juice. Heat olive oil in a pan.',
   'Put vegetables and turkey slices in the pan, sauté briefly. Add 150 ml of water to the pan. Simmer for a few minutes until the water has evaporated.',
   'Wash the chili pepper, cut into fine rings. Peel the garlic clove, chop it into fine pieces. Heat olive oil in a pot. Fry the chili slices and garlic pieces briefly in the saucepan. Add coconut milk and bring to a boil.',
   'Remove the pot from the heat. Add peanut butter and lemon juice. Season with salt and pepper.',
   'Serve vegetables and turkey slices with peanut sauce.' ],
portions: 2,
tags: [ 'Exotisch', 'Lunch' ] },
{ name: 'Beef fillet on paprika vegetables',
prev: 'rinderfilet_auf_paprikagemuse.jpg',
time: '30 min.',
ingredients:
 [ '2 beef fillets',
   ', 3 peppers (red, yellow)',
   '1 onion',
   '150 g mushrooms',
   '1 clove of garlic',
   '1 tbsp olive oil',
   ', Salt, pepper, paprika powder' ],
preparation:
 [ 'Heat olive oil in a pan. Peel the garlic clove, finely chop. Wash the peppers, remove seeds, cut into strips. Peel the onion, chop it into fine pieces. Wash mushrooms, finely chop.',
   'Season beef fillets with salt and pepper. Briefly fry the garlic pieces in the pan. Add beef fillets and fry for about 7 minutes from each side. Take out and warm up.',
   'Put the peppers, mushrooms and onions in the pan and sauté for 5 minutes. Season with salt and pepper.',
   'Serve roasted vegetables with beef fillets.' ],
portions: 2,
tags: [ 'Für Feinschmecker', 'Lunch' ] },
{ name: 'Bratkohlrabi',
prev: 'bratkohlrabi.jpg',
time: '30 min.',
ingredients:
 [ '1 onion',
   '1 kohlrabi',
   '2 slices of cooked ham',
   '1 tbsp olive oil',
   ',Salt pepper' ],
preparation:
 [ 'Peel the kohlrabi and cut into thin slices. Peel the onion and cut into thin slices.',
   'Heat olive oil in a pan. Put the kohlrabi slices in the pan and fry over medium heat until they are tender. In the meantime, cut the ham into strips.',
   'Add the onion rings and ham strips to the kohlrabi slices and season with salt and pepper.' ],
portions: 2,
tags: [ 'Low Carb', 'Lunch', 'Snacks' ] },
{ name: 'Spicy chickpea salad',
prev: 'scharfer_kichererbsensalat.jpg',
time: '10 min.',
ingredients:
 [ '300 g of precooked chickpeas',
   '1 onion',
   ', 4 cherry tomatoes',
   '1 pepper (red / yellow)',
   '1 clove of garlic',
   '1 tablespoon tomato paste',
   '1 tbsp olive oil',
   '1 tablespoon soy sauce',
   '1 tbsp of herbs (for example parsley)',
   ', Salt, pepper, paprika powder' ],
preparation:
 [ 'Peel garlic and onion, finely chop. Then mix with the tomato paste, olive oil, the soy sauce. Season with paprika powder.',
   'Wash the peppers and tomatoes, cut into small pieces. Mix with chickpeas and add dressing. Finally mix in herbs. Season with salt and pepper.' ],
portions: 2,
tags: [ 'Exotisch', 'Lunch', 'Dinner', 'Snacks', 'Vegan' ] },
{ name: 'Cucumber salmon baguette',
prev: 'gurken_lachs.jpg',
time: '10 min.',
ingredients:
 [ '1 big cucumber',
   '250 g salmon',
   ', 8 tablespoons cottage cheese',
   '2 tablespoons parsley (fresh or dried)',
   '1 clove of garlic',
   ', ½ lemon',
   '2 tablespoons peas from the tin',
   ',Salt pepper' ],
preparation:
 [ 'Peel garlic, finely chop.',
   'Wash cucumber, peel, cut in half. Carefully cut out the inside of the cucumber with a knife and chop it into fine pieces.',
   'Squeeze out the lemon. Mix the lemon juice & nbsp; with cottage cheese, garlic, peas, parsley and cucumber pieces.',
   'Spread the cucumber halves with the cream and cover with smoked salmon.' ],
portions: 2,
tags: [ 'Leicht', 'Breakfast', 'Dinner', 'Snacks' ] },
{ name: 'Tuna cottage cheese snack',
prev: 'thunfisch_huettenkaese.png',
time: '5 min.',
ingredients:
 [ '250 g cottage cheese',
   '1 tin of tuna (without oil)',
   '150 g quark',
   '1 spring onion',
   ',Salt pepper' ],
preparation:
 [ 'Wash the spring onion, cut into fine rings. Drain the tuna.',
   'Mix the tuna, cottage cheese and spring onions in a bowl.',
   'Season with salt and pepper.' ],
portions: 1,
tags: [ 'Superschnell', 'Breakfast', 'Dinner', 'Snacks' ] },
{ name: 'Vegetable sticks with dip',
prev: 'gemuesesticks.png',
time: '10 min.',
ingredients:
 [ '1 pepper',
   ', ½ cucumber',
   '2 carrots',
   ', ½ bunch of radishes',
   ', ½ zucchini',
   '250 g of low-fat quark',
   ', ½ bunch chives',
   ', ½ chilli pepper (alternatively chilli powder)',
   ', Salt, pepper, lemon juice' ],
preparation:
 [ 'Wash vegetables, peel and cut into thin strips.',
   'Wash chives and chili peppers, cut into fine rings.',
   'Mash quark with chives and chili peppers. Season with salt and pepper. Add a dash of lemon juice as desired. Serve dip in a small bowl with the vegetable sticks.' ],
portions: 1,
tags: [ 'Leicht', 'Dinner', 'Snacks' ] },
{ name: 'Champignon avocado snack',
prev: 'champignon_avocado_snack.jpg',
time: '25 min.',
ingredients:
 [ '1 avocado',
   '100 g mushrooms',
   ', ½ iceberg lettuce',
   '1 carrot',
   '1 tomato',
   '1 handful of cashew kernels',
   '2 tbsp olive oil',
   ', 4 tablespoons low-fat quark',
   ',Salt pepper' ],
preparation:
 [ 'Wash the iceberg lettuce, cut and place in a bowl. Carrot, wash tomato and cut into small pieces. Add to the bowl.',
   'Halve the avocado, remove the core and remove the avocado with a spoon. Process the avocado meat from one half to a pulp with a fork and cut the other half into small pieces.',
   'Heat olive oil in a pan. Wash mushrooms, cut. Add to the pan and sauté briefly. Add mushrooms over the remaining salad.',
   'Mix avocado porridge with lean quark. Finely chop the cashews and add to the avocado and quark mixture. Season with salt and pepper. Give the dressing over the salad.' ],
portions: 1,
tags: [ 'Gut vorzubereiten', 'Dinner', 'Snacks' ] },
{ name: 'Colorful salad with coconut coattail sauce',
prev: 'salat_mit_kokos_coacktailsauce.jpg',
time: '10 min.',
ingredients:
 [ '½ iceberg lettuce',
   '2 tomatoes',
   ', 30 g of ham',
   ', ½ cucumber',
   '2 boiled eggs',
   '200 ml of coconut milk',
   '1 tablespoon tomato paste',
   ', ½ tsp. Mustard',
   ', Salt, pepper, curry, paprika powder' ],
preparation:
 [ 'Wash vegetables, peel and cut into small pieces. Peel eggs, cut small. Cut ham into strips. Put all ingredients in a bowl.',
   'Mix tomato paste, coconut milk and mustard well together. Season as desired.',
   'Give the dressing over the salad.' ],
portions: 1,
tags: [ 'Exotisch', 'Dinner', 'Snacks' ] },
{ name: 'Tuna beans salad',
prev: 'thunfisch_bohnen.jpg',
time: '10 min.',
ingredients:
 [ '½ can of tuna in its own juice',
   ', 3 cherry tomatoes',
   ', 80 grams of kidney beans',
   '1 onion',
   ', 50 grams of corn',
   ', ¼ bunch of parsley',
   '1 tbsp olive oil',
   ',Salt pepper' ],
preparation:
 [ 'Wash tomatoes and cut small. Peel onion, finely chop. Drain beans and corn. Wash parsley, finely chop.',
   'Giving vegetables in a bowl. Give olive oil over it. Season with salt and pepper.' ],
portions: 1,
tags: [ 'Proteinreich', 'Dinner', 'Snacks' ] },
{ name: 'Protein Power Salad',
prev: 'protein_power.jpg',
time: '25 min.',
ingredients:
 [ '2 eggs',
   '1 piece of chicken fillet',
   '1 spring onion',
   '1 tbsp sunflower seeds',
   '1 tomato',
   ', ½ cucumber',
   '1 tbsp. Natural yoghurt',
   '1 tablespoon vinegar',
   '2 tbsp olive oil',
   '1/2 tsp mustard',
   ',Salt pepper' ],
preparation:
 [ 'Wash tomato, spring onion, cucumber and finely chop. Cut chicken fillet into strips. Heat the water in a pan and boil the eggs for 10 minutes. Peel eggs and cut into small pieces. Put all ingredients in a bowl.',
   'Heat olive oil in a pan. Sauté chicken strips. Season with salt and pepper. Add chicken strips to the bowl.',
   'Mix yoghurt, vinegar, 1 tbsp olive oil and mustard. Season with salt and pepper, add to the salad. Sprinkle salad with sunflower seeds as desired.' ],
portions: 1,
tags: [ 'Mit Hähnchenfilet', 'Dinner', 'Snacks' ] },
{ name: 'Avocado steak salad',
prev: 'avocado_steak.jpg',
time: '30 min.',
ingredients:
 [ '1 beef steak',
   '2 tbsp olive oil',
   ', 4 cherry tomatoes',
   ', ½ onion',
   ', ¼ head of iceberg lettuce',
   ', ½ cucumber',
   ', ½ avocado',
   '1 tsp honey',
   '1 tbsp lemon juice',
   ', Salt, pepper, chilli powder' ],
preparation:
 [ 'Heat olive oil in a pan. Season steak with salt and pepper and fry on medium heat for 4-6 minutes from each side.',
   'Mix the lemon juice with honey and 1 tablespoon of olive oil in a small bowl. Season with chili powder and pepper.',
   'Wash vegetables. Cut the salad into bite-sized pieces. Peel avocado, remove seeds and cut into fine pieces. Halve cherry tomatoes. Slice the onion and cucumber into thin slices. Cut steak into bite-sized pieces as well. Put all the ingredients in a bowl and pour over the dressing.' ],
portions: 1,
tags: [ 'Für Feinschmecker', 'Lunch', 'Dinner', 'Snacks' ] },
{ name: 'Tofu egg salad with quinoa',
prev: 'tofu_ei_salat_mit_quinoa.jpg',
time: '15 min.',
ingredients:
 [ '100 g of tofu',
   ', 50 g quinoa (raw)',
   '1 egg',
   '2 bars of spring onions',
   '1 tomato',
   ', ½ pepper',
   '1 tbsp olive oil',
   '2 tablespoons of lemon juice',
   '1 stick of parsley',
   ',Pepper' ],
preparation:
 [ 'Cook quinoa in salted water for 10 minutes. Boil egg for about 10 minutes.',
   'Roll the tofu. Wash tomatoes and peppers, cut into small pieces. Wash the spring onion, cut into fine rings. Wash parsley, finely chop.',
   'Mix olive oil with lemon juice. Season with pepper. Chop boiled egg.',
   'Mix the quinoa with the vegetables and the egg in a bowl. Give the dressing over and serve.' ],
portions: 1,
tags: [ 'Proteinreich', 'Dinner', 'Snacks' ] },
{ name: 'Fried egg with green beans and bacon',
prev: 'spiegelei_bohnen.jpg',
time: '15 min.',
ingredients:
 [ '1-2 eggs',
   '200 g of green beans',
   ', 50 g bacon or ham',
   '1 tbsp olive oil',
   ',Salt pepper' ],
preparation:
 [ 'Wash the green beans and cut off the ends. Heat the pot with salted water and cook the beans over medium heat for 10 minutes. Cut the bacon into small pieces.',
   'Heat olive oil in a pan. Sauté the bacon pieces and take them out. Then put the egg in the pan. Season with salt and pepper and add to a fried egg.',
   'Serve green beans, bacon and fried eggs on a plate. If necessary, season with salt and pepper.' ],
portions: 1,
tags: [ 'Deftig', 'Breakfast', 'Dinner', 'Snacks' ] },
{ name: 'Carrots zucchini buffer',
prev: 'karotten_zucchini_puffer.jpg',
time: '20 min.',
ingredients:
 [ '150 g of carrots',
   ', ½ zucchini',
   ', ½ tablespoon of lemon juice',
   '1 tbsp parsley',
   '1 egg',
   ', 4 tablespoons oatmeal',
   '2 tablespoons of low-fat herbal quark',
   '1 tbsp olive oil',
   ',Salt pepper' ],
preparation:
 [ 'Wash carrots and zucchini, peel and finely grate with a vegetable grater.',
   'Mix the grated vegetables with lemon juice, chopped parsley, egg and the oatmeal. Season with salt and pepper.',
   'Heat olive oil in a pan. With a spoon, stick out small portions and place in the heated pan. Slightly squeeze the dough and sauté the buffers from both sides over medium heat.',
   'Arrange the vegetable buffers with herb quark on a plate.' ],
portions: 1,
tags: [ 'Low Carb', 'Lunch', 'Dinner', 'Snacks' ] },
{ name: 'Basil beans salad',
prev: 'basilikum_bohnen.jpg',
time: '15 min.',
ingredients:
 [ '200 g of green beans',
   '1 tsp pine nuts',
   ', ¼ bunch of basil',
   ', ½ clove of garlic',
   '1 tbsp olive oil',
   ',Salt pepper' ],
preparation:
 [ 'Wash the green beans, cut off the ends and cook in salted water for 10 minutes.',
   'Wash the basil, peel the leaves and finely chop. Peel clove garlic, press.',
   'Garlic, basil with olive oil. Pour over the cooked beans and then sprinkle with pine nuts.' ],
portions: 1,
tags: [ 'Gut vorzubereiten', 'Dinner', 'Snacks', 'Vegan' ] },
{ name: 'Spinach Fried',
prev: 'spinat_spiegelei.jpg',
time: '15 min.',
ingredients:
 [ '3 eggs',
   ', 3 tablespoons low-fat yogurt',
   '150 g spinach (frozen or fresh)',
   '1 tsp olive oil',
   ', Paprika, chili powder, salt, pepper' ],
preparation:
 [ 'Heat olive oil in a pan. Put the spinach in the pan. Sauté briefly. Push spinach in the pan to the side.',
   'Open the eggs in the pan and replenish. Season with salt and pepper.',
   'Mix chilli powder with yoghurt. Then season with salt, pepper and paprika. Serve with the eggs and spinach.' ],
portions: 1,
tags: [ 'Voller Mineralstoffe', 'Breakfast', 'Dinner', 'Snacks' ] },
{ name: 'berry muesli',
prev: 'beerenmuesli.png',
time: '10 min.',
ingredients:
 [ '50 g of oatmeal',
   ', 30 g of almonds',
   '150 g berries (fresh or frozen)',
   '250 g of low-fat quark',
   '150 ml low-fat milk' ],
preparation:
 [ 'Fry almonds in a pan over medium heat for about 4 minutes. Then finely chop. Wash berries.',
   'Mix oatmeal, chopped almonds, fresh (or thawed berries), milk and skimmed curd cheese with each other.' ],
portions: 1,
tags: [ 'Nährstoffreich', 'Breakfast', 'Dinner', 'Snacks' ] },
{ name: 'Mediterranean scrambled eggs',
prev: 'mediteranes_ruehrei.png',
time: '15 min.',
ingredients:
 [ '3 eggs',
   ', 4 cherry tomatoes',
   '20 g of rocket',
   '100 g of low-fat feta',
   '1 tbsp olive oil',
   ',Pepper' ],
preparation:
 [ 'Wash tomatoes and rocket. Quarter the tomatoes and finely chop the rocket. Cut the feta cheese into small cubes.',
   'Put eggs and rocket in a bowl, whisk and season with pepper.',
   'Heat olive oil in a pan. Add the tomatoes to the pan and sauté briefly. Pour eggs into the pan and replenish. Season with pepper.',
   'Serve scrambled eggs on a plate and sprinkle with feta pieces.' ],
portions: 1,
tags: [ 'Proteinreich', 'Breakfast', 'Dinner', 'Snacks' ] },
{ name: 'Nut apple granola',
prev: 'nuss_apfel_muesli.jpg',
time: '5 min.',
ingredients:
 [ '1 apple',
   ', 30 grams of walnuts',
   ', 50 g of oatmeal',
   '200 g of lean quark',
   '150 ml low-fat milk',
   ',Cinnamon' ],
preparation:
 [ 'Wash apple, cut into small pieces. Chop nuts.',
   'Mix oatmeal, apple pieces, walnuts with lean quark and milk. Sprinkle cereal with cinnamon.' ],
portions: 1,
tags: [ 'Sättigend', 'Breakfast', 'Snacks' ] },
{ name: 'Bacon and Eggs',
prev: 'bacon_eggs.png',
time: '10 min.',
ingredients:
 [ '3 eggs',
   ', 4 low-fat bacon strips',
   '1 tbsp olive oil',
   ',Salt pepper' ],
preparation:
 [ 'Heat olive oil in a pan. Sauté bacon strips, remove and keep warm.',
   'Pour eggs into the pan and add to fried eggs. Season with salt and pepper.' ],
portions: 1,
tags: [ 'Deftig', 'Breakfast', 'Dinner', 'Snacks' ] },
{ name: 'Mint cucumber shake',
prev: 'minz_gurke.jpg',
time: '5 min.',
ingredients:
 [ '250 g of low-fat quark',
   '1 handful of fresh mint',
   ', ½ cucumber',
   ', ½ lemon',
   '200 ml of water' ],
preparation:
 [ 'Wash the cucumber and mint leaves. Cut the cucumber into small pieces. Squeeze out the lemon.',
   'Put all ingredients in a tall container and finely puree with a blender.' ],
portions: 1,
tags: [ 'Erfrischend', 'Dinner', 'Drink' ] },
{ name: 'Peach cucumber shake',
prev: 'pfirsich_gurke.jpg',
time: '10 min.',
ingredients:
 [ '2 peaches',
   ', ¼ cucumber',
   ', 50 ml of water',
   '200 g of natural yoghurt',
   '1 tsp honey' ],
preparation:
 [ 'Wash peaches and cucumber, cut into small pieces.',
   'Put natural yoghurt and water together with the pieces of peach and cucumber into a tall container. Purée with a hand blender. Sweeten with honey at will.',
   'Serve cold.' ],
portions: 1,
tags: [ 'Einfach', 'Dinner', 'Drink' ] },
{ name: 'Lime ginger iced tea',
prev: 'limetten_ingwer.jpg',
time: '15 min.',
ingredients:
 [ '4 bags of green tea',
   '2 limes',
   ', 35 g of fresh ginger',
   ', 500 ml of water',
   '2 tsp honey',
   'ice cube' ],
preparation:
 [ 'Wash ginger, peel and cut into thin slices. Wash limes, cut into thin slices.',
   'Boil water in a kettle. Put in a big container. Add ginger and lime slices and leave for about 5 minutes.',
   'Add the tea bag and leave for another 5 minutes. Take out the tea bag and sweeten it with 2 teaspoons honey. Allow the tea to cool.',
   'Serve ice cold with ice cubes.' ],
portions: 4,
tags: [ 'Aromatisch', 'Drink' ] },
{ name: 'Lemons iced tea',
prev: 'zitronen_eistee.jpg',
time: '15 min.',
ingredients:
 [ '4 bags of black tea',
   '1 orange',
   '1 lemon',
   ', 500 ml of water',
   'ice cube' ],
preparation:
 [ 'Wash orange and lemon and cut into thin slices.',
   'Boil the water in a kettle and place in a large container. Add the tea bag and leave for 5 minutes. Take out the bag.',
   'Put the lemon and orange slices in the warm tea. Allow to cool and let stand.',
   'Serve with egg cubes in a glass.' ],
portions: 4,
tags: [ 'Erfrischend', 'Drink' ] },
{ name: 'Lemons blueberry ice tea',
prev: 'zitronen_blaubeer.jpg',
time: '15 min.',
ingredients:
 [ '4 bags of green tea',
   '200 g blueberries',
   '1 lemon',
   ', 500 ml of water',
   'ice cube' ],
preparation:
 [ 'Wash lemon and blueberries. Cut the lemon into thin slices.',
   'Boil the water in a kettle and place in a large container. Add the tea bag and leave for about 5 minutes. Then remove the tea bag again.',
   'Add lemon slices and blueberries to the tea. Cool the tea in the refrigerator and leave to soak.',
   'Serve with egg cubes in a glass.' ],
portions: 4,
tags: [ 'Aromatisch', 'Drink' ] },
{ name: 'Pineapple orange smoothie',
prev: 'ananas_orange.jpg',
time: '5 min.',
ingredients:
 [ '150 g pineapple (3-4 rings of a pineapple)',
   '1 orange',
   '100 g of spinach',
   '250 ml of water' ],
preparation:
 [ 'Wash spinach and orange. Peel orange, cut into small pieces. Cut pineapple into small pieces.',
   'Put water, fruits and vegetables in a tall container. Purée with a blender.' ],
portions: 1,
tags: [ 'Exotisch', 'Drink', 'Vegan' ] },
{ name: 'Berry power smoothie',
prev: 'beeren_power.jpg',
time: '5 min.',
ingredients:
 [ '250g berries (for example strawberries)',
   ', ½ mango',
   '250ml of water',
   '100 g of spinach' ],
preparation:
 [ 'Wash berries, spinach and mango. Peel mango, cut into small pieces.',
   'Put water, fruits and vegetables in a tall container. Purée with a blender.' ],
portions: 1,
tags: [ 'Vitaminbombe', 'Drink', 'Vegan' ] },
{ name: 'Pears banana smoothie',
prev: 'birnen_bananen.jpg',
time: '5 min.',
ingredients:
 [ '2 pears', '1 banana', '100 g of spinach', '250 ml of water' ],
preparation:
 [ 'Wash pears and spinach. Peel banana. Cut fruit into small pieces.',
   'Put water, fruits and vegetables in a tall container. Purée with a blender.' ],
portions: 1,
tags: [ 'Fruchtig', 'Drink', 'Vegan' ] },
{ name: 'Parsley apple smoothie',
prev: 'petersilie_apfel.jpg',
time: '5 min.',
ingredients: [ '3 apples', '150 g parsley', '10 g of ginger' ],
preparation:
 [ 'Wash ginger, peel, finely chop. Wash apples and parsley. Cut apples into small pieces.',
   'Put all ingredients in a tall container. Purée with a blender.' ],
portions: 1,
tags: [ 'Originelle Idee', 'Drink', 'Vegan' ] },
{ name: 'Banana shake',
prev: 'bananen_shake.jpg',
time: '10 min.',
ingredients:
 [ '1 banana',
   '200 g of lean quark',
   '1 tsp honey',
   ', 400 ml of water' ],
preparation:
 [ 'Peel banana, cut small.',
   'Place honey, skimmed curd cheese and water in a tall container and puree with a hand blender.' ],
portions: 1,
tags: [ 'Der Klassiker', 'Snacks', 'Drink' ] },
{ name: 'Honey berry shake',
prev: 'honig_beeren.jpg',
time: '5 min.',
ingredients:
 [ '250 g of low-fat quark',
   '200 g frozen berries (e.g., blueberries)',
   '200 ml of water',
   '1 tsp honey' ],
preparation:
 [ 'Put all ingredients in a tall container and finely puree.',
   'If fresh berries are chosen, add a little crushed ice.' ],
portions: 1,
tags: [ 'Fruchtig', 'Snacks', 'Drink' ] },
{ name: 'Apple kiwi shake',
prev: 'apfel_kiwi_smoothie.jpg',
time: '5 min.',
ingredients:
 [ '1 apple',
   '1 ripe kiwi',
   ', 4 tablespoons natural yoghurt',
   ', 3 tablespoons of curd cheese',
   '2-3 ice cubes',
   '250 ml of still water' ],
preparation:
 [ 'Peel apple and kiwi. Core the apple. Cut fruit.',
   'Put all ingredients in a tall container. Purée with a blender.' ],
portions: 1,
tags: [ 'Superschnell', 'Snacks', 'Drink' ] },
{ name: 'Peach banana shake',
prev: 'pfirsich_bananen.jpg',
time: '10 min.',
ingredients:
 [ '1 ripe peach',
   '1 ripe banana',
   '1 tsp honey',
   ', 5 tablespoons low-fat quark',
   ', 300 ml of still cold water' ],
preparation:
 [ 'Wash peach. Peel banana and peach. Cut fruits into fine pieces.',
   'Put all the ingredients in a tall container and make a whisk with a hand blender.' ],
portions: 1,
tags: [ 'Vitaminbombe', 'Snacks', 'Drink' ] },
{ name: 'Kiwi Lemons Shake',
prev: 'kiwi_zitronen_shake.jpg',
time: '10 min.',
ingredients:
 [ '2 kiwis',
   ', 3 pineapple slices',
   ', ½ lemon',
   '1 tsp honey',
   '150 g of low-fat quark',
   '2 tsp crushed ice cream' ],
preparation:
 [ 'Peel kiwis, cut into small pieces. Cut the pineapple slices into small pieces. Squeeze out the lemon.',
   'Mix lemon juice with honey.',
   'Put all ingredients in a tall container and puree.' ],
portions: 1,
tags: [ 'Vitaminbombe', 'Snacks', 'Drink' ] },
{ name: 'Chocolate coconut shake',
prev: 'schoko_kokos.jpg',
time: '10 min.',
ingredients:
 [ '100 ml of coconut milk',
   '1 tsp cocoa powder (unsweetened)',
   '100 ml low-fat milk',
   '1 tbsp crushed ice',
   '1 tsp grated coconut' ],
preparation:
 [ 'Place cocoa powder with coconut milk, milk and ice in a sealable container (e.g., shaker). Shake vigorously.',
   'Sprinkle with coconut flakes as desired.' ],
portions: 1,
tags: [ 'Fruchtig-süß', 'Snacks', 'Drink' ] },
{ name: 'Power Booster Shake',
prev: 'starter_shake.png',
time: '5 min.',
ingredients:
 [ '40 g of oatmeal',
   '20 g popped amaranth',
   '100 g of berries e.g. blueberries',
   ', 400 ml of oatmeal',
   '1 tablespoon of flaxseed',
   ', 30 grams of walnut kernels',
   '1 tbsp agave syrup',
   ', 4 ice cubes',
   '1 teaspoon matcha powder' ],
preparation:
 [ 'Chop walnuts.', 'Put all ingredients in a blender and mix.' ],
portions: 1,
tags: [ 'Superschnell', 'Breakfast', 'Snacks', 'Vegan' ] },
{ name: 'Crunchy pancakes with raspberry cream',
prev: 'pancake.jpg',
time: '20 min.',
ingredients:
 [ '60 g wholemeal flour',
   '10 g agave syrup',
   '140 ml of soymilk',
   '1 tbsp olive oil',
   '1 teaspoon Baking powder',
   ', 30 g of popped amaranth',
   '150 g raspberries (frozen)',
   ', 30 g agave syrup',
   '100 g soya yogurt nature' ],
preparation:
 [ 'Mix the wholemeal flour, 10 g agave syrup, soy milk, baking powder and a little salt into a dough with a snowdrier. Then fold in the amaranth.',
   'Heat olive oil in a pan. Add one tablespoon of dough to the pan and gradually form about 6 small pancakes. Fry for about 4 minutes on both sides over medium heat.',
   'Put the raspberries, 30g agave syrup and the soy yoghurt in a blender and finely puree.',
   'Serve raspberry cream with the pancakes.' ],
portions: 2,
tags:
 [ 'Ballaststoffreiche Alternative',
   'Breakfast',
   'Snacks',
   'Vegan' ] },
{ name: 'Coconut Cranberry Muesli',
prev: 'cranberry_kokos.jpg',
time: '10 min.',
ingredients:
 [ '100 g of oatmeal',
   ', 50 g of coconut milk',
   ', 30 g agave syrup',
   ', 40 grams of cranberries',
   '160 g soy yoghurt',
   '2 slices of pineapple',
   ', 30 g of grated coconut' ],
preparation:
 [ 'Mix the oatmeal with coconut milk, agave syrup, cranberries and the soy yoghurt in a bowl. Let it rest for 4 minutes.',
   'Cut the pineapple slices into small pieces.',
   'Mix the pieces of pineapple and grated coconut with the remaining muesli.' ],
portions: 1,
tags: [ 'Nährstoffreich', 'Breakfast', 'Snacks', 'Vegan' ] },
{ name: 'Süßkartoffelsalat',
prev: 'suesskartoffelsalat.jpg',
time: '30 min.',
ingredients:
 [ '1 big sweet potato',
   '100 g mixed sprouts (e.g., radish sprouts)',
   '1/2 lemon',
   '2 tablespoons white wine vinegar',
   '1/2 tsp. Hot mustard',
   '1 teaspoon horseradish',
   ', 3 tablespoons olive oil',
   '1/2 bunch of coriander',
   '2 bars of spring onions',
   ',Salt pepper',
   ', & Nbsp;' ],
preparation:
 [ 'Wash sweet potato and cook in salted water until soft. Pour, peel & nbsp; and cut into small pieces.',
   'In the meantime, wash sprouts. Wash and squeeze the lemon. Mix lemon juice with vinegar, mustard, horseradish, salt and pepper. Gradually stir in olive oil.',
   'Wash cilantro, pat dry, peel off leaves. Wash spring onions and cut into fine rings.',
   'Put sweet potato pieces, cilantro, spring onions and sprouts in a bowl. Season with salt and pepper. Give the marinade over the salad and serve.' ],
portions: 2,
tags: [ 'Sättigend', 'Dinner', 'Snacks', 'Vegan' ] },
{ name: 'Beetroot soup with horseradish',
prev: 'rote_beete_suppe.jpg',
time: '30 min.',
ingredients:
 [ '1 onion',
   '1 sweet potato',
   ', 400 g of red beds',
   '1 tbsp olive oil',
   ', 800 ml of salted water (or vegetable stock)',
   '1 tbsp white wine vinegar',
   ', ground caraway',
   '1 tbsp horseradish',
   '100 ml of soy cream',
   ',Salt pepper' ],
preparation:
 [ 'Peel the onion and chop it into fine pieces. Wash the potatoes and beetroot, peel and cut into fine pieces.',
   'Heat olive oil in a pan. Briefly fry the onion in it. Add potatoes and beetroot and fry for a short time. Deglaze with salted water. Season with salt, pepper, vinegar and cumin. Cover and simmer for 20 minutes.',
   'Add horseradish and then purée the soup with a stamper. Stir in 100 ml of soy cream.' ],
portions: 2,
tags: [ 'Nährstoffreich', 'Lunch', 'Dinner', 'Vegan' ] },
{ name: 'Scrambled eggs made from tofu',
prev: 'tofu_ruehrei.png',
time: '15 min.',
ingredients:
 [ '200 g of soft natural tofu',
   '1 tbsp olive oil',
   '1 tbsp water',
   '2 cherry tomatoes',
   '1 stick of spring onion',
   '1/2 Tl turmeric',
   ',Salt pepper' ],
preparation:
 [ 'Crush tofu with a fork. Tomatoes, spring onion wash. Halve tomatoes. Cut the spring onion into fine rings.',
   'Sauté the tofu for about 3 minutes. Add the tomatoes and spring onion and sauté briefly. Season with turmeric, salt and pepper.' ],
portions: 1,
tags:
 [ 'Vegane Alternative', 'Breakfast', 'Dinner', 'Snacks', 'Vegan' ] },
{ name: 'Crunchy almond muesli',
prev: 'mandelmuesli.png',
time: '10 min.',
ingredients:
 [ '20 g amaranth popped',
   '25 g cornflakes (unsweetened)',
   ', 40 grams of oatmeal',
   '15 g roasted almonds',
   '20 g blueberries',
   '15 g of almonds',
   '20 grams of cranberries',
   '1 tablespoon of flaxseed',
   ', Fruits of your choice, e.g. 1 banana',
   '200 ml almond milk' ],
preparation:
 [ 'Mix amaranth, cornflakes, oatmeal, roasted almonds and almonds in a bowl.',
   'Wash berries. Peel the banana and cut into bite-sized pieces. Add the fruit to the bowl and mix with the other ingredients.',
   'Pour crunchy granola with almond milk.' ],
portions: 1,
tags: [ 'Mit Amaranth', 'Breakfast', 'Dinner', 'Snacks', 'Vegan' ] },
{ name: 'Meatballs with sweet potato puree',
prev: 'frikadellen_mit_suesskartoffel.jpg',
time: '30 min.',
ingredients:
 [ '400 g of carrots',
   '1 sweet potato',
   ', 300 g low-fat beef mince',
   '2 tablespoons of curd cheese',
   '2 tsp wholemeal breadcrumbs',
   '1 tbsp olive oil',
   ', 3 tablespoons chopped herbs',
   ', 3-4 tablespoons low-fat milk',
   ',Salt pepper' ],
preparation:
 [ 'Wash carrots and sweet potatoes, peel and cut into small pieces. Put in a pan filled with salt water and cook for about 15 minutes.',
   'In the meantime knead the meatloaf, the lean quark, the wholemeal breadcrumbs, herbs, salt and pepper together. Make 4 meatballs out of it.',
   'Heat olive oil in a pan. Brown meatballs over medium heat.',
   'Drain carrots and potatoes. Add low-fat milk and finely crush. Season with salt and pepper. Serve with the meatballs.' ],
portions: 2,
tags: [ 'Gesunde Alternative', 'Lunch' ] },
{ name: 'Beetroot tower with avocado cream',
prev: 'rote_beete_tower.jpg',
time: '20 min.',
ingredients:
 [ '250 g red beets',
   ', 300 g of natural tofu',
   ', 3 tablespoons olive oil',
   '2 teaspoons of agave syrup',
   '1 clove of garlic',
   ', 3 avocados',
   '1 tbsp lemon juice',
   ', some watercress',
   ',Salt pepper' ],
preparation:
 [ 'Wash beetroot, cut into thin slices. Heat the pot with salted water and cook for about 10 minutes until soft.',
   'Cut the tofu into 5 mm thick slices and then cut out with a small glass of red beetroot circles.',
   'Heat the olive oil in a pan and sauté the tofu for about 3 minutes from each side. Season with salt and pepper.',
   'Peel garlic, finely chop. Wash, halve and core avocados. Puree avocado with garlic and lemon juice. Season with salt and pepper.',
   'Layer tofu slices alternately with beetroot and avocado cream. Sprinkle with cress and serve.' ],
portions: 2,
tags: [ 'Originelle Idee', 'Lunch', 'Dinner', 'Snacks', 'Vegan' ] },
{ name: 'Kohlrabi ravioli with tomato basil sauce',
prev: 'kohlrabi_ravioli.jpg',
time: '30 min.',
ingredients:
 [ '2 kohlrabi',
   ', 6 tablespoons olive oil',
   '1 red pepper',
   '1 1/2 onions',
   '2 tomatoes',
   '1/2 bunch of basil',
   '2 cloves of garlic',
   ', Salt, pepper, oregano' ],
preparation:
 [ 'Wash kohlrabi, peel and slice or cut into very fine slices. Boil salted water in a saucepan, remove from heat and let the tender cuttlefish stew for about 10 minutes. Drain well with a paper towel. Mix 2 tablespoons of olive oil and 1 pinch of salt in a small bowl, add the kohlrabi slices and marinate.',
   'Wash the peppers, remove seeds and cut into fine pieces. Peel onions, finely chop. Heat 1 tablespoon of olive oil in a pan and sauté about 1/3 of the onion and paprika pieces for about 5 minutes. Remove the pan from the heat and crush the sautéed tomato and onion mixture with a fork. Season with oregano, salt and pepper. Put the pan back on the stove and heat briefly until the mixture is creamy.',
   'In the center of the marinated kohlrabi slices, add 1 tsp of paprika-onion mass. Put a second kohlrabi slice on top and press something on the side.',
   'Wash tomatoes and dice small. Peel garlic cloves, finely chop. Heat olive oil in a pan. Braise the remaining onions and garlic for about 2 minutes. Add tomatoes and cook briefly. Fold in basil. Season with salt and pepper.' ],
portions: 2,
tags: [ 'Gesunde Alternative', 'Lunch', 'Dinner', 'Vegan' ] },
{ name: 'Chocolate peanut ice cream',
prev: 'schoko_erdnuss_eis.jpg',
time: '25 min.',
ingredients:
 [ '200 g of peanut',
   '250 g ice cubes',
   ', 65g agave syrup',
   '1/2 teaspoon ground vanilla',
   ',Salt',
   ', 40 g of cocoa' ],
preparation:
 [ 'Mix peanut, agave syrup, ice cubes, salt and vanilla in a blender.',
   'Mix half of the mixture with cocoa. Mix both masses again with a fork.',
   'Cold ice in a bowl in a refrigerator for about 20 minutes.' ],
portions: 1,
tags: [ 'Erfrischend', 'Snacks', 'Vegan' ] },
{ name: 'Eggs with mustard sauce',
prev: 'eier_senf.jpg',
time: '25 min.',
ingredients:
 [ '4 eggs',
   '1 small onion',
   ', 50 ml low-fat milk',
   '2 teaspoons dill',
   '2 tablespoons cottage cheese',
   '2 tbsp low-fat yoghurt',
   ', 3 tsp mustard',
   '1 tsp olive oil',
   ',Salt pepper' ],
preparation:
 [ 'Boil eggs for about 10 minutes.',
   'Peel onion, finely chop.',
   'Heat olive oil in a pan. Sauté the onion cubes until they are glassy.',
   'Deglaze with milk. Stir in cottage cheese, yoghurt and mustard. Bring to a boil.',
   'Peel hard boiled eggs, halve and serve with sauce.' ],
portions: 1,
tags: [ 'Proteinreich', 'Breakfast', 'Dinner', 'Snacks' ] },
{ name: 'parsleyrootsoup',
prev: 'petersiliensuppe.jpg',
time: '30 min.',
ingredients:
 [ '200g parsley root',
   ', ½ red onion',
   '1 clove of garlic',
   '200g cottage cheese',
   ', ½ bunch of parsley',
   '250 ml of water',
   '1 l of olive oil',
   ',Salt pepper' ],
preparation:
 [ 'Wash the parsley root, cut in half and cut into slices.',
   'Peel the onion and garlic, finely dice.',
   'Heat olive oil in a pot. Put the parsley root, onion and garlic cubes in the pan and sauté for about 5 minutes.',
   'Add water and simmer for about 20 minutes.',
   'Meanwhile, wash the parsley, dry and finely chop. Puree the soup with a hand blender after the end of the cooking time. Add cottage cheese and sprinkle with parsley.' ],
portions: 1,
tags: [ 'Aromatisch', 'Lunch', 'Dinner', 'Snacks' ] },
{ name: 'Carrots cucumber smoothie',
prev: 'moere_gurken_smothie.jpg',
time: '5 min.',
ingredients:
 [ '1 cucumber',
   ', 300ml carrot juice (unsweetened)',
   ', 50g of oatmeal',
   '200g thin quark',
   '100ml of water' ],
preparation:
 [ 'Wash cucumber, cut into pieces.',
   'Mix all ingredients in a blender and finely puree until a creamy shake is formed.' ],
portions: 1,
tags: [ 'Mahlzeitersatz', 'Drink' ] }
]


// WEBPACK FOOTER //
// ./src/store/fitnes/modules/recipts/ie.js